<template>
  <div class="modelReg">
    <div class="modelReg__grid">
    <div class="modelReg__title">
      <h3>{{ $t('modal.auth_modal_state.registration_successfully.title') }}</h3>

      <div class="modelReg__alertLoading" v-if="loader"></div>
      <div class="modelReg__alertError" v-if="errorMessage">{{ errorMessage }}</div>
      <div class="modelReg__alertSuccess" v-if="successMessage">{{ successMessage }}</div>

      <p>
        {{ $t('modal.auth_modal_state.registration_successfully.sub_title1') }}
        {{ form.email }}
        {{ $t('modal.auth_modal_state.registration_successfully.sub_title2') }}
      </p>
    </div>

    <div class="modelReg__grid-btn">
      <UiButtonMain
        size="xl"
        :label="$t('modal.auth_modal_state.registration_successfully.btn_resend')"
        @click="fetchRegistrationAgain"
      ></UiButtonMain>
      <UiButtonMain
        size="xl"
        :label="$t('modal.auth_modal_state.registration_successfully.btn_change_email')"
        variant="soft"
        @click="openModalRegistration"
      ></UiButtonMain>
    </div>
  </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import apiAuth from '~/entities/auth';
import { modalStateEnum } from '@shared/model';
import { useResponseStatusesState } from '@shared/lib';
import { useAuthStore } from '~/features/auth';
import { useUserProfileStore } from '@entities/user';

const storeAuth = useAuthStore();
const storeUserProfile = useUserProfileStore();
const { responseStatusesState } = useResponseStatusesState();
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
      confirmPassword: '',
      twoFA: '',
      codeFromEmail: '',
    }),
  },
});
const form = ref(props.userData);
const { t } = useI18n();
const loader = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);

const fetchRegistrationAgain = () => {
  const params = {
    email: form.value.email,
  };
  loader.value = true;
  apiAuth
    .resendEmail(params)
    .then((data) => {
      const responseCode = data.code;
      successMessage.value = responseStatusesState[responseCode];
    })
    .catch((error) => {
      const responseCode = error.data.code || 5000;
      errorMessage.value = responseStatusesState[responseCode];
    })
    .finally(() => {
      loader.value = false;
      setTimeout(() => {
        errorMessage.value = null;
        successMessage.value = null;
      }, 6000);
    });
};

const openModalRegistration = () => {
  storeModal.stateAuthModal(modalStateEnum.Registration);
};
</script>

<style scoped lang="scss"></style>


